/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { $Configuration } from 'CoreTypes/Configuration';
import type { $StoreState } from '../../types/StoreState';
import type { $Translation } from 'CoreTypes/Translation';
import FilterType from 'CoreConstants/FilterType';
import WidgetFieldKeys from '../../constants/WidgetFieldsKeys';
import { TemplateMarketPropertyKeys } from 'CoreTemplates/TemplateMarketProperties';
import { getFilterItemsList } from 'CoreComponents/DealersFilteringActivityTypes/DealersFilteringActivityTypesSSF';
import { getWidgetFieldValueByKey } from 'CoreUtils/WidgetFieldUtils';
import { modifyFilterCriteria } from 'CoreStore/filters';
import { showWidgetField } from 'CoreUtils/WidgetFieldUtils';
import WBDropdown from '../../../../dealer-locator-core/src/components/WBDropdown/WBDropdown';

type $ComponentProps = {
  checkedFilterActivities: Array<string>,
  filterExpanded: boolean,
  onFilterActivityTypeCheck: Function,
  onFilterClose: Function
};

type $MappedProps = {
  appliedFilteringValues: Array<string>,
  configuration: $Configuration,
  market: string,
  translations: Array<$Translation>,
  filterDropdownPlaceholder: string,
  showFilterDropdownPlaceholder: boolean,
  modifyFilterCriteria: Function,
  searchCount: number
};

type $Props = $ComponentProps & $MappedProps;

class SearchResultsActivityTypeFilterGeneric extends Component<$Props> {

  handleFilteringChange = (value: string) => {
    this.props.modifyFilterCriteria(FilterType.FILTER_ACTIVITY_TYPE, [value]);
    this.props.onFilterActivityTypeCheck([value]);
  };

  render() {

    const {
      configuration,
      market,
      filterDropdownPlaceholder,
      searchCount,
      showFilterDropdownPlaceholder,
      translations
    } = this.props;

    const enabledActivityTypes = getFilterItemsList(
      market, configuration, translations, TemplateMarketPropertyKeys.GEN_FILTERS_ACTIVITY_TYPES_ENABLED);

    if (enabledActivityTypes.values.length > 0 && enabledActivityTypes.labels.length > 0 && searchCount > 0) {
      const labels = [filterDropdownPlaceholder, ...enabledActivityTypes.labels];
      const values = ["", ...enabledActivityTypes.values];

      return (
        <div className="dsw-search-results-filter__dropdown">
          <WBDropdown
            placeholder={showFilterDropdownPlaceholder ? filterDropdownPlaceholder : ''}
            labels={labels}
            values={values}
            selectedValue={this.props.appliedFilteringValues.length > 0 ?
              this.props.appliedFilteringValues[0] : ''}
            onChange={this.handleFilteringChange}
            modifierClass={'dsw-search-results-filter__dropdown__wb'}
          />
        </div>
      );
    }
    else return null;
  }
}

const mapStateToProps = (state: $StoreState) => ({
  configuration: state.dsw.configuration,
  market: state.dsw.settings.market,
  translations: state.dsw.translations,
  filterDropdownPlaceholder: getWidgetFieldValueByKey(WidgetFieldKeys.FILTERING_ACTIVITY_TYPES_LABEL, state.dsw),
  showFilterDropdownPlaceholder: showWidgetField(state.dsw.settings, WidgetFieldKeys.FILTERING_ACTIVITY_TYPES_LABEL),
  appliedFilteringValues: state.dsw.filters[ FilterType.FILTER_ACTIVITY_TYPE ] || [],
  searchCount: state.dsw.search.searchCount || 0
});

const mapDispatchToProps: Object = {
  modifyFilterCriteria
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsActivityTypeFilterGeneric);
